/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Icon = void 0;

var _iconography = require("./iconography");

exports.Icon = _iconography.Icon;